<template>
  <div>
    <Head title="Profilo" />
    <h1 class="mb-8 text-3xl font-bold">Profilo</h1>

    <!-- Profile Information -->
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mb-8">
      <form @submit.prevent="updateProfile">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.first_name"
            :error="form.errors.first_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nome"
          />
          <text-input
            v-model="form.last_name"
            :error="form.errors.last_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Cognome"
          />
          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Email"
            type="email"
          />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-end">
          <loading-button :loading="form.processing" class="btn-blue" type="submit">
            Aggiorna Profilo
          </loading-button>
        </div>
      </form>
    </div>

    <!-- Change Password -->
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mb-8">
      <form @submit.prevent="updatePassword">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full">
            <h2 class="text-xl font-semibold mb-4">Cambia Password</h2>
          </div>
          <text-input
            v-model="passwordForm.current_password"
            :error="passwordForm.errors.current_password"
            class="pr-6 pb-8 w-full"
            label="Password Attuale"
            type="password"
          />
          <text-input
            v-model="passwordForm.password"
            :error="passwordForm.errors.password"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nuova Password"
            type="password"
          />
          <text-input
            v-model="passwordForm.password_confirmation"
            :error="passwordForm.errors.password_confirmation"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Conferma Password"
            type="password"
          />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-end">
          <loading-button :loading="passwordForm.processing" class="btn-blue" type="submit">
            Cambia Password
          </loading-button>
        </div>
      </form>
    </div>

    <!-- Delete Account -->
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <div class="p-8">
        <h2 class="text-xl font-semibold mb-4 text-red-600">Elimina Account</h2>
        <p class="text-gray-600 mb-4">
          Una volta eliminato il tuo account, tutti i tuoi dati saranno eliminati permanentemente.
          Se hai prenotazioni future, non potrai eliminare il tuo account.
        </p>
        <button
          class="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700"
          @click="showDeleteConfirm = true"
        >
          Elimina Account
        </button>
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <div v-if="showDeleteConfirm" class="fixed z-10 inset-0 overflow-y-auto">
      <div class="flex items-center justify-center min-h-screen px-4">
        <div class="fixed inset-0 bg-gray-500 opacity-75" @click="showDeleteConfirm = false" />
        <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all max-w-lg w-full z-20">
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <h3 class="text-lg font-medium text-gray-900 mb-4">Conferma Eliminazione Account</h3>
            <p class="text-sm text-gray-500">
              Sei sicuro di voler eliminare il tuo account? Questa azione non può essere annullata.
            </p>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 sm:ml-3 sm:w-auto sm:text-sm"
              type="button"
              @click="deleteAccount"
            >
              Elimina
            </button>
            <button
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              type="button"
              @click="showDeleteConfirm = false"
            >
              Annulla
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountLayout from "@/Pages/Account/Shared/AccountLayout.vue";
import LoadingButton from "@/Pages/Dashboard/Shared/LoadingButton.vue";
import TextInput from "@/Pages/Dashboard/Shared/TextInput.vue";
import { Head } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Head,
    LoadingButton,
    TextInput,
  },
  layout: AccountLayout,
  props: {
    user: Object,
  },
  data() {
    return {
      showDeleteConfirm: false,
      form: this.$inertia.form({
        first_name: this.user.first_name || "",
        last_name: this.user.last_name || "",
        email: this.user.email || "",
      }),
      passwordForm: this.$inertia.form({
        current_password: "",
        password: "",
        password_confirmation: "",
      }),
    };
  },
  methods: {
    updateProfile() {
      this.form.put("/account/profile");
    },
    updatePassword() {
      this.passwordForm.put("/account/profile", {
        onSuccess: () => {
          this.passwordForm.reset();
        },
      });
    },
    deleteAccount() {
      this.$inertia.delete("/account/delete", {
        onFinish: () => {
          this.showDeleteConfirm = false;
        },
      });
    },
  },
};
</script>

<style scoped>
.btn-blue {
  @apply px-6 py-3 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500;
}
</style>
